import { render, staticRenderFns } from "./StructureTreeSelect.vue?vue&type=template&id=8e71a962&"
import script from "./StructureTreeSelect.vue?vue&type=script&lang=ts&"
export * from "./StructureTreeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports